var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 0H2.57143C1.15127 0 0 1.15127 0 2.57143V12.8571C0 14.2773 1.15127 15.4286 2.57143 15.4286H21.4286C22.8487 15.4286 24 14.2773 24 12.8571V2.57143C24 1.15127 22.8487 0 21.4286 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M21.4286 0H2.57143C1.15114 0 0 1.15114 0 2.57143V12.8571C0 14.2774 1.15114 15.4286 2.57143 15.4286H21.4286C22.8489 15.4286 24 14.2774 24 12.8571V2.57143C24 1.15114 22.8489 0 21.4286 0ZM23.1429 12.8571C23.1429 13.8026 22.374 14.5714 21.4286 14.5714H2.57143C1.626 14.5714 0.857143 13.8026 0.857143 12.8571V2.57143C0.857143 1.626 1.626 0.857143 2.57143 0.857143H21.4286C22.374 0.857143 23.1429 1.626 23.1429 2.57143V12.8571Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4289 0.857178H2.57171C1.62456 0.857178 0.857422 1.62432 0.857422 2.57146V3.42861C0.857422 2.48146 1.62456 1.71432 2.57171 1.71432H21.4289C22.376 1.71432 23.1431 2.48146 23.1431 3.42861V2.57146C23.1431 1.62432 22.376 0.857178 21.4289 0.857178Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76425 4.82056L7.33168 10.6234H5.7451L4.54768 5.99227C4.47482 5.7077 4.41225 5.60313 4.1911 5.48227C3.83025 5.28599 3.23368 5.10256 2.70996 4.98856L2.7451 4.82056H5.29939C5.6251 4.82056 5.91739 5.03741 5.99196 5.41199L6.62453 8.77027L8.18625 4.82056H9.76425Z",
    fill: "#1434CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9826 8.72823C15.9895 7.19652 13.8655 7.11166 13.88 6.42766C13.8843 6.21938 14.0832 5.99823 14.5169 5.94166C14.732 5.91423 15.3252 5.89195 15.9972 6.20138L16.2603 4.97052C15.8995 4.84023 15.434 4.71423 14.8563 4.71423C13.3717 4.71423 12.3277 5.5028 12.32 6.63252C12.3106 7.46823 13.0657 7.93366 13.634 8.21223C14.2195 8.4968 14.4157 8.67938 14.4132 8.93309C14.4089 9.32223 13.946 9.49452 13.5157 9.50138C12.7606 9.51338 12.3226 9.29738 11.9737 9.13452L11.7012 10.4065C12.0526 10.5677 12.6997 10.7074 13.37 10.7142C14.948 10.7142 15.9792 9.93509 15.9843 8.72823",
    fill: "#1434CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0769 4.82056H18.7963C18.5074 4.82056 18.2649 4.9877 18.1569 5.2457L15.9043 10.6234H17.4806L17.7934 9.75684H19.7194L19.9012 10.6234H21.2897L20.0769 4.82056ZM18.2254 8.56799L19.0157 6.38913L19.47 8.56799H18.2254Z",
    fill: "#1434CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.909 4.82056L10.6678 10.6234H9.16699L10.4081 4.82056H11.909Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.df92c815a6ab80b3c73bddaef3efded7.svg";
export { ForwardRef as ReactComponent };